export interface CreateCorporatePositionDto {
  title: string; // Required, max 200
  description?: string | null; // Max 1000
  department?: string | null; // Max 100
  level?: number; // Range 1-10, default: 1
  isActive?: boolean; // Default: true
  isDefault?: boolean; // Default: false
}
